// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-tabs-container {
  width: 100%;
  overflow: hidden;
  border-bottom: 1.5px solid #3b82f6;
}

.custom-tabs-list {
  display: flex;
  overflow-x: hidden;
  flex-wrap: nowrap;
}

.custom-tab {
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #64748b;
  border: 1.5px solid #e2e8f0;
  border-bottom: none;
  background: #ffffff;
  padding: 10px 16px;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  flex-shrink: 0;
}
.custom-tab:hover {
  color: #3b82f6;
  border-color: #3b82f6;
}
.custom-tab.active {
  background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
  border-color: #3b82f6;
  color: #1e293b;
  font-weight: 600;
}
.custom-tab.add-new-tab {
  color: #3b82f6;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: auto;
  padding: 10px 12px;
}
.custom-tab.add-new-tab .plus-icon {
  flex-shrink: 0;
}
.custom-tab.add-new-tab:hover {
  background: #eff6ff;
}

.mapping-profile-tabs {
  width: 100%;
}
.mapping-profile-tabs .ant-tabs-nav {
  margin-bottom: 0;
  overflow: hidden;
}
.mapping-profile-tabs .ant-tabs-nav::before {
  display: none;
}
.mapping-profile-tabs .ant-tabs-nav-wrap {
  overflow: hidden !important;
  flex: 1 1;
  min-width: 0;
}
.mapping-profile-tabs .ant-tabs-nav-list {
  overflow: hidden !important;
  flex-wrap: nowrap !important;
}
.mapping-profile-tabs .ant-tabs-nav-operations {
  display: flex !important;
  flex-shrink: 0;
}
.mapping-profile-tabs .ant-tabs-tab {
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #64748b;
  border-radius: 8px 8px 0 0;
  border: 1.5px solid #e2e8f0;
  background: #ffffff;
  padding: 10px 16px;
  margin-right: 4px;
  transition: all 0.2s ease;
}
.mapping-profile-tabs .ant-tabs-tab:hover {
  color: #3b82f6;
  border-color: #3b82f6;
}
.mapping-profile-tabs .ant-tabs-tab.ant-tabs-tab-active {
  background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
  border-color: #3b82f6;
  border-bottom-color: transparent;
}
.mapping-profile-tabs .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
  color: #1e293b;
  font-weight: 600;
}
.mapping-profile-tabs .ant-tabs-ink-bar {
  display: none;
}
.mapping-profile-tabs .ant-tabs-content-holder {
  display: none;
}
.mapping-profile-tabs .ant-tabs-nav-wrap::before, .mapping-profile-tabs .ant-tabs-nav-wrap::after {
  display: none;
}
.mapping-profile-tabs .ant-tabs-nav-more {
  border: 1.5px solid #e2e8f0;
  background: #ffffff;
  border-radius: 8px 8px 0 0;
  padding: 10px 12px;
  margin-right: 4px;
  transition: all 0.2s ease;
}
.mapping-profile-tabs .ant-tabs-nav-more:hover {
  border-color: #3b82f6;
  background: #f8fafc;
}
.mapping-profile-tabs .ant-tabs-nav-more .more-icon {
  display: flex;
  align-items: center;
  justify-content: center;
}
.mapping-profile-tabs .ant-tabs-nav-more .more-icon circle {
  transition: fill 0.2s ease;
}
.mapping-profile-tabs .ant-tabs-nav-more:hover .more-icon circle {
  fill: #3b82f6;
}

.ant-tabs-dropdown.mapping-tabs-dropdown .ant-tabs-dropdown-menu,
.ant-tabs-dropdown.mapping-tabs-dropdown .ant-dropdown-menu,
.ant-dropdown.mapping-tabs-dropdown .ant-tabs-dropdown-menu,
.ant-dropdown.mapping-tabs-dropdown .ant-dropdown-menu {
  background: #ffffff;
  border: 1.5px solid #e2e8f0;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  padding: 4px;
  min-width: 200px;
}
.ant-tabs-dropdown.mapping-tabs-dropdown .ant-tabs-dropdown-menu .ant-tabs-dropdown-menu-item,
.ant-tabs-dropdown.mapping-tabs-dropdown .ant-tabs-dropdown-menu .ant-dropdown-menu-item,
.ant-tabs-dropdown.mapping-tabs-dropdown .ant-dropdown-menu .ant-tabs-dropdown-menu-item,
.ant-tabs-dropdown.mapping-tabs-dropdown .ant-dropdown-menu .ant-dropdown-menu-item,
.ant-dropdown.mapping-tabs-dropdown .ant-tabs-dropdown-menu .ant-tabs-dropdown-menu-item,
.ant-dropdown.mapping-tabs-dropdown .ant-tabs-dropdown-menu .ant-dropdown-menu-item,
.ant-dropdown.mapping-tabs-dropdown .ant-dropdown-menu .ant-tabs-dropdown-menu-item,
.ant-dropdown.mapping-tabs-dropdown .ant-dropdown-menu .ant-dropdown-menu-item {
  font-family: "Inter", sans-serif;
  font-size: 14px;
  padding: 10px 16px;
  border-radius: 6px;
  transition: all 0.2s ease;
}
.ant-tabs-dropdown.mapping-tabs-dropdown .ant-tabs-dropdown-menu .ant-tabs-dropdown-menu-item:hover,
.ant-tabs-dropdown.mapping-tabs-dropdown .ant-tabs-dropdown-menu .ant-dropdown-menu-item:hover,
.ant-tabs-dropdown.mapping-tabs-dropdown .ant-dropdown-menu .ant-tabs-dropdown-menu-item:hover,
.ant-tabs-dropdown.mapping-tabs-dropdown .ant-dropdown-menu .ant-dropdown-menu-item:hover,
.ant-dropdown.mapping-tabs-dropdown .ant-tabs-dropdown-menu .ant-tabs-dropdown-menu-item:hover,
.ant-dropdown.mapping-tabs-dropdown .ant-tabs-dropdown-menu .ant-dropdown-menu-item:hover,
.ant-dropdown.mapping-tabs-dropdown .ant-dropdown-menu .ant-tabs-dropdown-menu-item:hover,
.ant-dropdown.mapping-tabs-dropdown .ant-dropdown-menu .ant-dropdown-menu-item:hover {
  background: #f8fafc;
  color: #3b82f6;
}
.ant-tabs-dropdown.mapping-tabs-dropdown .ant-tabs-dropdown-menu .ant-tabs-dropdown-menu-item.ant-tabs-dropdown-menu-item-active, .ant-tabs-dropdown.mapping-tabs-dropdown .ant-tabs-dropdown-menu .ant-tabs-dropdown-menu-item.ant-dropdown-menu-item-active,
.ant-tabs-dropdown.mapping-tabs-dropdown .ant-tabs-dropdown-menu .ant-dropdown-menu-item.ant-tabs-dropdown-menu-item-active,
.ant-tabs-dropdown.mapping-tabs-dropdown .ant-tabs-dropdown-menu .ant-dropdown-menu-item.ant-dropdown-menu-item-active,
.ant-tabs-dropdown.mapping-tabs-dropdown .ant-dropdown-menu .ant-tabs-dropdown-menu-item.ant-tabs-dropdown-menu-item-active,
.ant-tabs-dropdown.mapping-tabs-dropdown .ant-dropdown-menu .ant-tabs-dropdown-menu-item.ant-dropdown-menu-item-active,
.ant-tabs-dropdown.mapping-tabs-dropdown .ant-dropdown-menu .ant-dropdown-menu-item.ant-tabs-dropdown-menu-item-active,
.ant-tabs-dropdown.mapping-tabs-dropdown .ant-dropdown-menu .ant-dropdown-menu-item.ant-dropdown-menu-item-active,
.ant-dropdown.mapping-tabs-dropdown .ant-tabs-dropdown-menu .ant-tabs-dropdown-menu-item.ant-tabs-dropdown-menu-item-active,
.ant-dropdown.mapping-tabs-dropdown .ant-tabs-dropdown-menu .ant-tabs-dropdown-menu-item.ant-dropdown-menu-item-active,
.ant-dropdown.mapping-tabs-dropdown .ant-tabs-dropdown-menu .ant-dropdown-menu-item.ant-tabs-dropdown-menu-item-active,
.ant-dropdown.mapping-tabs-dropdown .ant-tabs-dropdown-menu .ant-dropdown-menu-item.ant-dropdown-menu-item-active,
.ant-dropdown.mapping-tabs-dropdown .ant-dropdown-menu .ant-tabs-dropdown-menu-item.ant-tabs-dropdown-menu-item-active,
.ant-dropdown.mapping-tabs-dropdown .ant-dropdown-menu .ant-tabs-dropdown-menu-item.ant-dropdown-menu-item-active,
.ant-dropdown.mapping-tabs-dropdown .ant-dropdown-menu .ant-dropdown-menu-item.ant-tabs-dropdown-menu-item-active,
.ant-dropdown.mapping-tabs-dropdown .ant-dropdown-menu .ant-dropdown-menu-item.ant-dropdown-menu-item-active {
  background: #eff6ff;
  color: #1e293b;
  font-weight: 600;
}

.tab-label {
  display: flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
}
.tab-label.add-new-tab {
  color: #3b82f6;
  font-weight: 500;
}
.tab-label.add-new-tab .plus-icon {
  flex-shrink: 0;
}
.tab-label.add-new-tab .plus-icon path {
  stroke: currentColor;
}

.default-badge-tab {
  font-size: 12px;
  color: #10b981;
  font-weight: 600;
  margin-left: 4px;
}

.mapping-section {
  padding: 8px 24px;
  background: #ffffff;
}

.mapping-profile-section {
  padding: 10px 24px;
  margin-top: 26px;
}

.mapping-profile-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 24px;
  overflow: hidden;
  min-width: 0;
}

.section-title {
  font-family: "Inter", sans-serif;
  font-size: 15px;
  font-weight: 600;
  color: #1e293b;
  margin: 0;
}

.filter-group {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}

.filter-group-left {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1 1;
}

.filter-group-right {
  display: flex;
  align-items: center;
  gap: 8px;
}

.filter-group-filters {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 30px;
  width: 100%;
}

.filter-group-dropdown {
  display: flex;
  align-items: center;
  gap: 12px;
}

.field-name-display {
  display: flex;
  align-items: center;
  gap: 10px;
  min-height: 42px;
}

.default-badge {
  height: 20px;
  padding: 4px 10px;
  text-transform: none;
  border-radius: 12px;
  display: inline-flex;
  align-items: center;
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  color: white;
  font-family: "Inter", sans-serif;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.5px;
  box-shadow: 0 2px 4px rgba(16, 185, 129, 0.2);
}

.field-name-text {
  font-family: "Inter", sans-serif;
  font-size: 15px;
  font-weight: 600;
  color: #1e293b;
}

.edit-icon-button {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 6px;
  background: transparent;
  border: none;
  cursor: pointer;
  border-radius: 6px;
  transition: all 0.2s ease;
}
.edit-icon-button:hover {
  background: #f1f5f9;
}
.edit-icon-button:active {
  transform: scale(0.95);
}
.edit-icon-button svg {
  width: 16px;
  height: 16px;
}

.field-name-edit-container {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 42px;
}

.field-name-input-container {
  flex: 1 1;
  min-width: 200px;
  max-width: 280px;
}

.field-name-input {
  width: 250px;
  padding: 10px 14px;
  border: 1.5px solid #cbd5e1;
  border-radius: 10px;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #1e293b;
  background: #ffffff;
  transition: all 0.2s ease;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}
.field-name-input:hover {
  border-color: #94a3b8;
}
.field-name-input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
.field-name-input::placeholder {
  color: #94a3b8;
}

.field-name-save-button {
  padding: 4px 12px;
  background: #2196F3;
  color: white;
  border: none;
  border-radius: 8px;
  font-family: "Inter", sans-serif;
  font-size: 13px;
  font-weight: 600;
  height: 34px;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(16, 185, 129, 0.3);
}
.field-name-save-button:hover {
  background: linear-gradient(135deg, #059669 0%, #047857 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(16, 185, 129, 0.4);
}
.field-name-save-button:active {
  transform: translateY(0);
}

.field-name-cancel-button {
  padding: 4px 12px;
  background: #ffffff;
  color: #64748b;
  border: 1.5px solid #cbd5e1;
  border-radius: 8px;
  font-family: "Inter", sans-serif;
  font-size: 13px;
  font-weight: 600;
  height: 34px;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}
.field-name-cancel-button:hover {
  background: #f8fafc;
  border-color: #94a3b8;
}
.field-name-cancel-button:active {
  transform: translateY(1px);
}

.field-action-button {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 10px 16px;
  height: 34px;
  border-radius: 8px;
  font-family: "Inter", sans-serif;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;
  background: #ffffff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}
.field-action-button svg {
  width: 14px;
  height: 14px;
}
.field-action-button:active:not(:disabled) {
  transform: translateY(1px);
}

.duplicate-button {
  color: #3b82f6 !important;
  border: 1.5px solid #3b82f6 !important;
}
.duplicate-button:hover {
  background: #eff6ff !important;
  border-color: #2563eb !important;
  color: #2563eb !important;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(59, 130, 246, 0.2);
}

.delete-button {
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%) !important;
  color: white !important;
  border: 1px solid #ef4444;
  box-shadow: 0 1px 2px rgba(239, 68, 68, 0.2);
}
.delete-button span {
  color: white;
}
.delete-button:hover:not(:disabled) {
  background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%) !important;
  border-color: #dc2626;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(239, 68, 68, 0.3);
}
.delete-button:active:not(:disabled) {
  transform: translateY(0);
}
.delete-button.disabled, .delete-button:disabled {
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
  color: white !important;
  border-color: #ef4444;
  cursor: not-allowed;
  box-shadow: none;
  opacity: 0.5;
}
.delete-button.disabled span, .delete-button:disabled span {
  color: white;
}
.delete-button.disabled:hover, .delete-button:disabled:hover {
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
  transform: none;
}
.delete-button .delete-icon {
  width: 12px;
  height: 12px;
  filter: brightness(0) invert(1);
}
.delete-button.disabled .delete-icon, .delete-button:disabled .delete-icon {
  filter: brightness(0) invert(1);
  opacity: 1;
}

.make-default-button {
  color: #10b981 !important;
  border: 1.5px solid #10b981 !important;
  background: #ffffff !important;
}
.make-default-button:hover {
  background: #ecfdf5 !important;
  border-color: #059669 !important;
  color: #059669 !important;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(16, 185, 129, 0.2);
}
.make-default-button .make-default-icon {
  color: currentColor;
  transition: color 0.2s ease;
}
.make-default-button svg {
  width: 12px;
  height: 12px;
}

.is-default-button {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%) !important;
  color: white !important;
  border: 1.5px solid #10b981 !important;
  cursor: default !important;
  box-shadow: 0 1px 2px rgba(16, 185, 129, 0.2) !important;
}
.is-default-button:hover {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%) !important;
  transform: none !important;
}
.is-default-button .make-default-icon {
  color: currentColor;
}
.is-default-button svg {
  width: 12px;
  height: 12px;
}

.mapping-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  background: #ffffff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.mapping-table-subheader {
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  border-bottom: 2px solid #e2e8f0;
}
.mapping-table-subheader th {
  padding: 14px 16px;
  text-align: left;
  font-family: "Inter", sans-serif;
  font-size: 13px;
  font-weight: 600;
  color: #475569;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.mapping-table-header-row {
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
  transition: background 0.2s ease;
}
.mapping-table-header-row:hover {
  background: #f1f5f9;
}
.mapping-table-header-row .mapping-table-header-cell {
  padding: 14px 10px;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  background-color: #fff !important;
  font-weight: 600;
  color: #1e293b;
  cursor: pointer;
  display: flex;
  align-items: center;
  white-space: nowrap;
  gap: 0 !important;
}
.mapping-table-header-row .mapping-table-header-cell > span {
  white-space: nowrap;
}
.mapping-table-header-row .mapping-table-header-cell .expand-icon {
  transition: transform 0.3s ease;
  transform: rotate(-90deg);
  flex-shrink: 0;
}
.mapping-table-header-row .mapping-table-header-cell .expand-icon.expanded {
  transform: rotate(0deg);
}
.mapping-table-header-row .mapping-table-header-cell .expand-icon path {
  stroke: #64748b;
}
.mapping-table-header-row .mapping-table-header-cell .section-description {
  font-weight: 400;
  color: #64748b;
  font-size: 12px;
  white-space: nowrap;
}

.mapping-tab-actions {
  display: flex;
  justify-content: flex-end;
  padding: 8px 24px;
  background: linear-gradient(to top, #f8fafc 0%, #ffffff 100%);
  border-top: 1px solid #e2e8f0;
}
.mapping-tab-actions .save-all-button {
  padding: 11px 32px;
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
  color: white;
  border: none;
  border-radius: 10px;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(59, 130, 246, 0.3);
  letter-spacing: 0.3px;
}
.mapping-tab-actions .save-all-button:hover:not(:disabled) {
  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
  box-shadow: 0 4px 8px rgba(59, 130, 246, 0.4);
  transform: translateY(-1px);
}
.mapping-tab-actions .save-all-button:active:not(:disabled) {
  transform: translateY(0);
}
.mapping-tab-actions .save-all-button:disabled {
  background: #cbd5e1;
  color: #94a3b8;
  cursor: not-allowed;
  box-shadow: none;
}`, "",{"version":3,"sources":["webpack://./src/pages/Integrations/HubspotIntegration/components/MappingTab/mapping-tab.scss"],"names":[],"mappings":"AACA;EACE,WAAA;EACA,gBAAA;EACA,kCAAA;AAAF;;AAGA;EACE,aAAA;EAEA,kBAAA;EACA,iBAAA;AADF;;AAIA;EACE,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EAEA,2BAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;AAFF;AAIE;EACE,cAAA;EACA,qBAAA;AAFJ;AAKE;EACE,6DAAA;EACA,qBAAA;EACA,cAAA;EACA,gBAAA;AAHJ;AAOE;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;AALJ;AAOI;EACE,cAAA;AALN;AAQI;EACE,mBAAA;AANN;;AAYA;EACE,WAAA;AATF;AAWE;EACE,gBAAA;EACA,gBAAA;AATJ;AAWI;EACE,aAAA;AATN;AAaE;EACE,2BAAA;EACA,SAAA;EACA,YAAA;AAXJ;AAcE;EACE,2BAAA;EACA,4BAAA;AAZJ;AAeE;EACE,wBAAA;EACA,cAAA;AAbJ;AAgBE;EACE,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,0BAAA;EACA,2BAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,yBAAA;AAdJ;AAgBI;EACE,cAAA;EACA,qBAAA;AAdN;AAiBI;EACE,6DAAA;EACA,qBAAA;EACA,gCAAA;AAfN;AAiBM;EACE,cAAA;EACA,gBAAA;AAfR;AAoBE;EACE,aAAA;AAlBJ;AAqBE;EACE,aAAA;AAnBJ;AAuBI;EAEE,aAAA;AAtBN;AA2BE;EACE,2BAAA;EACA,mBAAA;EACA,0BAAA;EACA,kBAAA;EACA,iBAAA;EACA,yBAAA;AAzBJ;AA2BI;EACE,qBAAA;EACA,mBAAA;AAzBN;AA4BI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AA1BN;AA4BM;EACE,0BAAA;AA1BR;AA8BI;EACE,aAAA;AA5BN;;AAoCE;;;;EAEE,mBAAA;EACA,2BAAA;EACA,kBAAA;EACA,yCAAA;EACA,YAAA;EACA,gBAAA;AA/BJ;AAiCI;;;;;;;;EAEE,gCAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;AAzBN;AA2BM;;;;;;;;EACE,mBAAA;EACA,cAAA;AAlBR;AAqBM;;;;;;;;;;;;;;;EAEE,mBAAA;EACA,cAAA;EACA,gBAAA;AANR;;AAYA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;AATF;AAWE;EACE,cAAA;EACA,gBAAA;AATJ;AAWI;EACE,cAAA;AATN;AAWM;EACE,oBAAA;AATR;;AAeA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;AAZF;;AAgBA;EACE,iBAAA;EACA,mBAAA;AAbF;;AAgBA;EACE,kBAAA;EACA,gBAAA;AAbF;;AAkBA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,YAAA;AAfF;;AAkBA;EACE,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;AAfF;;AAkBA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AAfF;;AAkBA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,SAAA;AAfF;;AAkBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAfF;;AAkBA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,WAAA;AAfF;;AAkBA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAfF;;AAkBA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;AAfF;;AAkBA;EACE,YAAA;EACA,iBAAA;EACA,oBAAA;EACA,mBAAA;EACA,oBAAA;EACA,mBAAA;EACA,6DAAA;EACA,YAAA;EACA,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,6CAAA;AAfF;;AAkBA;EACE,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAfF;;AAkBA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,uBAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;AAfF;AAiBE;EACE,mBAAA;AAfJ;AAkBE;EACE,sBAAA;AAhBJ;AAmBE;EACE,WAAA;EACA,YAAA;AAjBJ;;AAqBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;AAlBF;;AAqBA;EACE,SAAA;EACA,gBAAA;EACA,gBAAA;AAlBF;;AAqBA;EACE,YAAA;EACA,kBAAA;EACA,2BAAA;EACA,mBAAA;EACA,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,yCAAA;AAlBF;AAoBE;EACE,qBAAA;AAlBJ;AAqBE;EACE,aAAA;EACA,qBAAA;EACA,6CAAA;AAnBJ;AAsBE;EACE,cAAA;AApBJ;;AAwBA;EACE,iBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,6CAAA;AArBF;AAuBE;EACE,6DAAA;EACA,2BAAA;EACA,6CAAA;AArBJ;AAwBE;EACE,wBAAA;AAtBJ;;AA0BA;EACE,iBAAA;EACA,mBAAA;EACA,cAAA;EACA,2BAAA;EACA,kBAAA;EACA,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,yCAAA;AAvBF;AAyBE;EACE,mBAAA;EACA,qBAAA;AAvBJ;AA0BE;EACE,0BAAA;AAxBJ;;AA4BA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,YAAA;EACA,mBAAA;EACA,yCAAA;AAzBF;AA2BE;EACE,WAAA;EACA,YAAA;AAzBJ;AA4BE;EACE,0BAAA;AA1BJ;;AA8BA;EACE,yBAAA;EACA,sCAAA;AA3BF;AA6BE;EACE,8BAAA;EACA,gCAAA;EACA,yBAAA;EACA,2BAAA;EACA,6CAAA;AA3BJ;;AA+BA;EACE,wEAAA;EACA,uBAAA;EACA,yBAAA;EACA,4CAAA;AA5BF;AA8BE;EACE,YAAA;AA5BJ;AA+BE;EACE,wEAAA;EACA,qBAAA;EACA,2BAAA;EACA,4CAAA;AA7BJ;AAgCE;EACE,wBAAA;AA9BJ;AAiCE;EAEE,6DAAA;EACA,uBAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;AAhCJ;AAkCI;EACE,YAAA;AAhCN;AAmCI;EACE,6DAAA;EACA,eAAA;AAjCN;AAqCE;EACE,WAAA;EACA,YAAA;EACA,+BAAA;AAnCJ;AAsCE;EAEE,+BAAA;EACA,UAAA;AArCJ;;AAyCA;EACE,yBAAA;EACA,sCAAA;EACA,8BAAA;AAtCF;AAwCE;EACE,8BAAA;EACA,gCAAA;EACA,yBAAA;EACA,2BAAA;EACA,6CAAA;AAtCJ;AAyCE;EACE,mBAAA;EACA,2BAAA;AAvCJ;AA0CE;EACE,WAAA;EACA,YAAA;AAxCJ;;AA4CA;EACE,wEAAA;EACA,uBAAA;EACA,sCAAA;EACA,0BAAA;EACA,wDAAA;AAzCF;AA2CE;EACE,wEAAA;EACA,0BAAA;AAzCJ;AA4CE;EACE,mBAAA;AA1CJ;AA6CE;EACE,WAAA;EACA,YAAA;AA3CJ;;AAgDA;EACE,WAAA;EACA,yBAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,wCAAA;AA7CF;;AAgDA;EACE,6DAAA;EACA,gCAAA;AA7CF;AA+CE;EACE,kBAAA;EACA,gBAAA;EACA,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,qBAAA;AA7CJ;;AAiDA;EACE,mBAAA;EACA,gCAAA;EACA,gCAAA;AA9CF;AAgDE;EACE,mBAAA;AA9CJ;AAiDE;EACE,kBAAA;EACA,gCAAA;EACA,eAAA;EACA,iCAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,iBAAA;AA/CJ;AAiDI;EACE,mBAAA;AA/CN;AAkDI;EACE,+BAAA;EACA,yBAAA;EACA,cAAA;AAhDN;AAkDM;EACE,uBAAA;AAhDR;AAmDM;EACE,eAAA;AAjDR;AAqDI;EACE,gBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;AAnDN;;AAyDA;EACE,aAAA;EACA,yBAAA;EACA,iBAAA;EACA,6DAAA;EACA,6BAAA;AAtDF;AAwDE;EACE,kBAAA;EACA,6DAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,6CAAA;EACA,qBAAA;AAtDJ;AAwDI;EACE,6DAAA;EACA,6CAAA;EACA,2BAAA;AAtDN;AAyDI;EACE,wBAAA;AAvDN;AA0DI;EACE,mBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;AAxDN","sourcesContent":["// Profile Tabs Styles - Custom Pure CSS Tabs\n.custom-tabs-container {\n  width: 100%;\n  overflow: hidden;\n  border-bottom: 1.5px solid #3b82f6;\n}\n\n.custom-tabs-list {\n  display: flex;\n  // gap: 4px;\n  overflow-x: hidden;\n  flex-wrap: nowrap;\n}\n\n.custom-tab {\n  font-family: \"Inter\", sans-serif;\n  font-size: 14px;\n  font-weight: 500;\n  color: #64748b;\n  // border-radius: 8px 8px 0 0;\n  border: 1.5px solid #e2e8f0;\n  border-bottom: none;\n  background: #ffffff;\n  padding: 10px 16px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  white-space: nowrap;\n  flex-shrink: 0;\n\n  &:hover {\n    color: #3b82f6;\n    border-color: #3b82f6;\n  }\n\n  &.active {\n    background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);\n    border-color: #3b82f6;\n    color: #1e293b;\n    font-weight: 600;\n    // border-bottom: 5px solid #e2e8f0;\n  }\n\n  &.add-new-tab {\n    color: #3b82f6;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    min-width: auto;\n    padding: 10px 12px;\n\n    .plus-icon {\n      flex-shrink: 0;\n    }\n\n    &:hover {\n      background: #eff6ff;\n    }\n  }\n}\n\n// Old Ant Design styles (kept for reference, can be removed)\n.mapping-profile-tabs {\n  width: 100%;\n\n  .ant-tabs-nav {\n    margin-bottom: 0;\n    overflow: hidden;\n\n    &::before {\n      display: none;\n    }\n  }\n\n  .ant-tabs-nav-wrap {\n    overflow: hidden !important;\n    flex: 1;\n    min-width: 0;\n  }\n\n  .ant-tabs-nav-list {\n    overflow: hidden !important;\n    flex-wrap: nowrap !important;\n  }\n\n  .ant-tabs-nav-operations {\n    display: flex !important;\n    flex-shrink: 0;\n  }\n\n  .ant-tabs-tab {\n    font-family: \"Inter\", sans-serif;\n    font-size: 14px;\n    font-weight: 500;\n    color: #64748b;\n    border-radius: 8px 8px 0 0;\n    border: 1.5px solid #e2e8f0;\n    background: #ffffff;\n    padding: 10px 16px;\n    margin-right: 4px;\n    transition: all 0.2s ease;\n\n    &:hover {\n      color: #3b82f6;\n      border-color: #3b82f6;\n    }\n\n    &.ant-tabs-tab-active {\n      background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);\n      border-color: #3b82f6;\n      border-bottom-color: transparent;\n\n      .ant-tabs-tab-btn {\n        color: #1e293b;\n        font-weight: 600;\n      }\n    }\n  }\n\n  .ant-tabs-ink-bar {\n    display: none;\n  }\n\n  .ant-tabs-content-holder {\n    display: none;\n  }\n\n  .ant-tabs-nav-wrap {\n    &::before,\n    &::after {\n      display: none;\n    }\n  }\n\n  // More button for overflow tabs\n  .ant-tabs-nav-more {\n    border: 1.5px solid #e2e8f0;\n    background: #ffffff;\n    border-radius: 8px 8px 0 0;\n    padding: 10px 12px;\n    margin-right: 4px;\n    transition: all 0.2s ease;\n\n    &:hover {\n      border-color: #3b82f6;\n      background: #f8fafc;\n    }\n\n    .more-icon {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n\n      circle {\n        transition: fill 0.2s ease;\n      }\n    }\n\n    &:hover .more-icon circle {\n      fill: #3b82f6;\n    }\n  }\n}\n\n// Dropdown menu for overflow tabs\n.ant-tabs-dropdown.mapping-tabs-dropdown,\n.ant-dropdown.mapping-tabs-dropdown {\n  .ant-tabs-dropdown-menu,\n  .ant-dropdown-menu {\n    background: #ffffff;\n    border: 1.5px solid #e2e8f0;\n    border-radius: 8px;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n    padding: 4px;\n    min-width: 200px;\n\n    .ant-tabs-dropdown-menu-item,\n    .ant-dropdown-menu-item {\n      font-family: \"Inter\", sans-serif;\n      font-size: 14px;\n      padding: 10px 16px;\n      border-radius: 6px;\n      transition: all 0.2s ease;\n\n      &:hover {\n        background: #f8fafc;\n        color: #3b82f6;\n      }\n\n      &.ant-tabs-dropdown-menu-item-active,\n      &.ant-dropdown-menu-item-active {\n        background: #eff6ff;\n        color: #1e293b;\n        font-weight: 600;\n      }\n    }\n  }\n}\n\n.tab-label {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  white-space: nowrap;\n\n  &.add-new-tab {\n    color: #3b82f6;\n    font-weight: 500;\n\n    .plus-icon {\n      flex-shrink: 0;\n\n      path {\n        stroke: currentColor;\n      }\n    }\n  }\n}\n\n.default-badge-tab {\n  font-size: 12px;\n  color: #10b981;\n  font-weight: 600;\n  margin-left: 4px;\n}\n\n// Mapping Section & Filter Styles\n.mapping-section {\n  padding: 8px 24px;\n  background: #ffffff;\n}\n\n.mapping-profile-section {\n  padding: 10px 24px;\n  margin-top: 26px;\n  // background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);\n  // border-bottom: 1px solid #e2e8f0;\n}\n\n.mapping-profile-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 24px;\n  overflow: hidden;\n  min-width: 0;\n}\n\n.section-title {\n  font-family: \"Inter\", sans-serif;\n  font-size: 15px;\n  font-weight: 600;\n  color: #1e293b;\n  margin: 0;\n}\n\n.filter-group {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.filter-group-left {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex: 1;\n}\n\n.filter-group-right {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.filter-group-filters {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-top: 30px;\n  width: 100%;\n}\n\n.filter-group-dropdown {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.field-name-display {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-height: 42px;\n}\n\n.default-badge {\n  height: 20px;\n  padding: 4px 10px;\n  text-transform: none;\n  border-radius: 12px;\n  display: inline-flex;\n  align-items: center;\n  background: linear-gradient(135deg, #10b981 0%, #059669 100%);\n  color: white;\n  font-family: \"Inter\", sans-serif;\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0.5px;\n  box-shadow: 0 2px 4px rgba(16, 185, 129, 0.2);\n}\n\n.field-name-text {\n  font-family: \"Inter\", sans-serif;\n  font-size: 15px;\n  font-weight: 600;\n  color: #1e293b;\n}\n\n.edit-icon-button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 6px;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  border-radius: 6px;\n  transition: all 0.2s ease;\n\n  &:hover {\n    background: #f1f5f9;\n  }\n\n  &:active {\n    transform: scale(0.95);\n  }\n\n  svg {\n    width: 16px;\n    height: 16px;\n  }\n}\n\n.field-name-edit-container {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-height: 42px;\n}\n\n.field-name-input-container {\n  flex: 1;\n  min-width: 200px;\n  max-width: 280px;\n}\n\n.field-name-input {\n  width: 250px;\n  padding: 10px 14px;\n  border: 1.5px solid #cbd5e1;\n  border-radius: 10px;\n  font-family: \"Inter\", sans-serif;\n  font-size: 14px;\n  font-weight: 500;\n  color: #1e293b;\n  background: #ffffff;\n  transition: all 0.2s ease;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n\n  &:hover {\n    border-color: #94a3b8;\n  }\n\n  &:focus {\n    outline: none;\n    border-color: #3b82f6;\n    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n  }\n\n  &::placeholder {\n    color: #94a3b8;\n  }\n}\n\n.field-name-save-button {\n  padding: 4px 12px;\n  background: #2196F3;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-family: \"Inter\", sans-serif;\n  font-size: 13px;\n  font-weight: 600;\n  height: 34px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  box-shadow: 0 2px 4px rgba(16, 185, 129, 0.3);\n\n  &:hover {\n    background: linear-gradient(135deg, #059669 0%, #047857 100%);\n    transform: translateY(-1px);\n    box-shadow: 0 4px 8px rgba(16, 185, 129, 0.4);\n  }\n\n  &:active {\n    transform: translateY(0);\n  }\n}\n\n.field-name-cancel-button {\n  padding: 4px 12px;\n  background: #ffffff;\n  color: #64748b;\n  border: 1.5px solid #cbd5e1;\n  border-radius: 8px;\n  font-family: \"Inter\", sans-serif;\n  font-size: 13px;\n  font-weight: 600;\n  height: 34px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n\n  &:hover {\n    background: #f8fafc;\n    border-color: #94a3b8;\n  }\n\n  &:active {\n    transform: translateY(1px);\n  }\n}\n\n.field-action-button {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 10px 16px;\n  height: 34px;\n  border-radius: 8px;\n  font-family: \"Inter\", sans-serif;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  border: none;\n  background: #ffffff;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n\n  svg {\n    width: 14px;\n    height: 14px;\n  }\n\n  &:active:not(:disabled) {\n    transform: translateY(1px);\n  }\n}\n\n.duplicate-button {\n  color: #3b82f6 !important;\n  border: 1.5px solid #3b82f6 !important;\n\n  &:hover {\n    background: #eff6ff !important;\n    border-color: #2563eb !important;\n    color: #2563eb !important;\n    transform: translateY(-1px);\n    box-shadow: 0 2px 4px rgba(59, 130, 246, 0.2);\n  }\n}\n\n.delete-button {\n  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%) !important;\n  color: white !important;\n  border: 1px solid #ef4444;\n  box-shadow: 0 1px 2px rgba(239, 68, 68, 0.2);\n\n  span {\n    color: white;\n  }\n\n  &:hover:not(:disabled) {\n    background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%) !important;\n    border-color: #dc2626;\n    transform: translateY(-1px);\n    box-shadow: 0 2px 4px rgba(239, 68, 68, 0.3);\n  }\n\n  &:active:not(:disabled) {\n    transform: translateY(0);\n  }\n\n  &.disabled,\n  &:disabled {\n    background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);\n    color: white !important;\n    border-color: #ef4444;\n    cursor: not-allowed;\n    box-shadow: none;\n    opacity: 0.5;\n\n    span {\n      color: white;\n    }\n\n    &:hover {\n      background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);\n      transform: none;\n    }\n  }\n\n  .delete-icon {\n    width: 12px;\n    height: 12px;\n    filter: brightness(0) invert(1);\n  }\n\n  &.disabled .delete-icon,\n  &:disabled .delete-icon {\n    filter: brightness(0) invert(1);\n    opacity: 1;\n  }\n}\n\n.make-default-button {\n  color: #10b981 !important;\n  border: 1.5px solid #10b981 !important;\n  background: #ffffff !important;\n\n  &:hover {\n    background: #ecfdf5 !important;\n    border-color: #059669 !important;\n    color: #059669 !important;\n    transform: translateY(-1px);\n    box-shadow: 0 2px 4px rgba(16, 185, 129, 0.2);\n  }\n\n  .make-default-icon {\n    color: currentColor;\n    transition: color 0.2s ease;\n  }\n\n  svg {\n    width: 12px;\n    height: 12px;\n  }\n}\n\n.is-default-button {\n  background: linear-gradient(135deg, #10b981 0%, #059669 100%) !important;\n  color: white !important;\n  border: 1.5px solid #10b981 !important;\n  cursor: default !important;\n  box-shadow: 0 1px 2px rgba(16, 185, 129, 0.2) !important;\n\n  &:hover {\n    background: linear-gradient(135deg, #10b981 0%, #059669 100%) !important;\n    transform: none !important;\n  }\n\n  .make-default-icon {\n    color: currentColor;\n  }\n\n  svg {\n    width: 12px;\n    height: 12px;\n  }\n}\n\n// Mapping Table Styles\n.mapping-table {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  background: #ffffff;\n  border-radius: 12px;\n  overflow: hidden;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.mapping-table-subheader {\n  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);\n  border-bottom: 2px solid #e2e8f0;\n\n  th {\n    padding: 14px 16px;\n    text-align: left;\n    font-family: \"Inter\", sans-serif;\n    font-size: 13px;\n    font-weight: 600;\n    color: #475569;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n  }\n}\n\n.mapping-table-header-row {\n  background: #f8fafc;\n  border-bottom: 1px solid #e2e8f0;\n  transition: background 0.2s ease;\n\n  &:hover {\n    background: #f1f5f9;\n  }\n\n  .mapping-table-header-cell {\n    padding: 14px 10px;\n    font-family: \"Inter\", sans-serif;\n    font-size: 14px;\n    background-color: #fff !important;\n    font-weight: 600;\n    color: #1e293b;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    white-space: nowrap;\n    gap: 0 !important;\n\n    > span {\n      white-space: nowrap;\n    }\n\n    .expand-icon {\n      transition: transform 0.3s ease;\n      transform: rotate(-90deg);\n      flex-shrink: 0;\n\n      &.expanded {\n        transform: rotate(0deg);\n      }\n\n      path {\n        stroke: #64748b;\n      }\n    }\n\n    .section-description {\n      font-weight: 400;\n      color: #64748b;\n      font-size: 12px;\n      white-space: nowrap;\n    }\n  }\n}\n\n// Mapping Tab Actions\n.mapping-tab-actions {\n  display: flex;\n  justify-content: flex-end;\n  padding: 8px 24px;\n  background: linear-gradient(to top, #f8fafc 0%, #ffffff 100%);\n  border-top: 1px solid #e2e8f0;\n\n  .save-all-button {\n    padding: 11px 32px;\n    background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);\n    color: white;\n    border: none;\n    border-radius: 10px;\n    font-family: \"Inter\", sans-serif;\n    font-size: 14px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    box-shadow: 0 2px 4px rgba(59, 130, 246, 0.3);\n    letter-spacing: 0.3px;\n\n    &:hover:not(:disabled) {\n      background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);\n      box-shadow: 0 4px 8px rgba(59, 130, 246, 0.4);\n      transform: translateY(-1px);\n    }\n\n    &:active:not(:disabled) {\n      transform: translateY(0);\n    }\n\n    &:disabled {\n      background: #cbd5e1;\n      color: #94a3b8;\n      cursor: not-allowed;\n      box-shadow: none;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
